/**
 * Where the SiteSmith edit overlay talks to the portal.
 *
 * Both helpers exist because edit mode was dead on production with no
 * error anyone saw (found 2026-11-01):
 *
 * - The storefront project never had NEXT_PUBLIC_PORTAL_URL, so the
 *   layout's `portalUrl` gate was always false and the overlay never
 *   mounted. Fall back to the production portal, as forwardLead.ts and
 *   the quote renewal route already hardcode it.
 * - The overlay is cross-origin, so every POST is preceded by a CORS
 *   preflight. A preflight carries no body, so an `action` sent only in
 *   the JSON body never reaches the portal dispatcher's token-authed
 *   branches: the OPTIONS request falls through to the admin gate and
 *   gets a 401 without CORS headers. The action must be in the URL.
 */

export const DEFAULT_PORTAL_URL = 'https://central.siflyfoils.com'

export function resolvePortalUrl(envValue: string | undefined): string {
  const v = envValue?.trim()
  return (v || DEFAULT_PORTAL_URL).replace(/\/+$/, '')
}

export function siteBuilderEndpoint(portalUrl: string, action: string): string {
  return `${portalUrl}/api/site-builder?action=${encodeURIComponent(action)}`
}
